<template>
  <main
    class="body-service d-flex justify-content-center align-items-center text-center"
  >
    <div class="color col-md-12 col-sm-12 text-center">
      <h1>Services</h1>
      <p class="col-md-12 col-sm-12">
        At Fhenix, We pride ourselves on delivering exceptional service and
        building long-lasting relationships with our clients. Our goal is to
        help you achieve your objectives and succeed in the digital age. Whether
        you're looking to learn a skill, develop a custom application, or get a
        workspace, we have the skills and expertise to deliver results.
      </p>
    </div>
  </main>

  <div class="serving py-5" id="backup">
    <div class="container">
      <div class="our-service text-center">
        <h2>Our Services</h2>
        <p>
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint.
        </p>
      </div>
      <div class="row rowing">
        <div
          class="col-lg-4 ram col-md-6"
          v-for="service in services"
          :key="service.id"
        >
          <div class="training px-3 py-4" @click="showCard(service)">
            <div class="image">
              <img
                :src="require(`@/assets/Images/${service.img}.png`)"
                alt=""
                class="img-fluid"
              />
            </div>
            <div class="minia">
              <small class="">{{ service.scheme }}</small>
              <p class="h-100">
                {{
                  `${
                    service.status
                      ? service.paragraph
                      : service.paragraph.substring(0, 100)
                  }`
                }}
                
                <!-- <span
                  class="link"
                  role="button"
                  @click.prevent="service.status = true"
                  v-if="service.status == false"
                  >...Read More</span
                >
                <span
                  class="link"
                  role="button"
                  @click.prevent="service.status = false"
                  v-else
                  >...Read Less</span
                > -->
              </p>

              <span class="link" @click="showCard(service)" role="button">View</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="rating-me py-5" id="service-details">
    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-6">
          <div class="android">
            <h3>{{ clickedService.scheme }}</h3>
            <p>
              {{ clickedService.paragraph }}
            </p>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="focus">
            <img src="../assets/Images/phone.png" alt="" class="img-fluid" />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-5">
        <a
          class="go-up d-flex justify-content-center align-items-center"
          href="#backup"
          >Go back to services
          <img src="../assets/Images/up.png" alt="" class="img-fluid ml-1" />
        </a>
      </div>
    </div>
  </section>

  <section class="w-100">
    <div class="container">
      <div class="row col-lg-12 p-3">
        <div class="col-lg-9 col-md-12 col-sm-12 d-flex align-items-center">
          <div content-box p-4>
            <h2 class="excel-header pt-4">Excellence is our language.</h2>
            <p class="pb-3 bt-2 excel-text">
              Are you ready to take your tech career to the next level? Look no
              further than our tech training center! Our expert instructors are
              dedicated to providing hands-on training that gives you practical
              skills that will set you apart from the rest
            </p>

            <p class="pb-3 bt-2 excel-text">
              Our training programs are tailored to your needs, ensuring that
              you get the most out of your learning experience. We pride
              ourselves on producing high-quality graduates, with a proven track
              record of connecting them with top-tier companies and job
              opportunities. Whether you're an entrepreneur, freelancer, or
              business looking to enhance your skills, our training center is
              the right place for you. Get in touch with us today and take the
              first step toward achieving your tech goals!
            </p>

            <div>
              <button class="bg-primary text-white px-4 py-2 excel-btn rounded">
                Register
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-3 d-flex flex-column px-4 align-end">
          <div class="pt-4">
            <img
              src="../assets/Images/tri-image-1.png"
              alt=""
              class="img-fluid"
            />
          </div>

          <div class="pt-4">
            <img
              src="../assets/Images/tri-image-3.png"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="contact-us py-5">
    <Contact />
  </div>
</template>

<script>
import Contact from "@/components/Contact.vue";
let id = 0;
export default {
  data() {
    return {
      services: [
        {
          id: id++,

          scheme: "Corporate Training",

          paragraph:
            "Our corporate training services offer customized learning solutions that cater to businesses' unique needs. We provide practical and interactive training that helps organizations enhance their employees' skills and productivity. We are committed to delivering high- quality training that drives business success. ",

          status: false,
          img: "service1",
        },

        {
          id: id++,
          scheme: "Co-Workspace",
          paragraph:
            "We offer a flexible co-working space that provides entrepreneurs, freelancers, and businesses with an affordable and collaborative work environment. You can choose either our daily, weekly, or monthly plans, with indoor and outdoor options to accommodate your unique requirements. Additionally, we provide an executive workspace that accommodates up to four people for meetings or collaborative teamwork. ; ",
          status: false,
          img: "co-workplace-icon",
        },

        {
          id: id++,
          scheme: "Talent Outsourcing",
          paragraph:
            "Our training center produces skilled graduates with practical experience that meets industry demands. Our proven track record of connecting our graduates with top-tier companies and job opportunities is a testament to our commitment to producing high- quality talent. Partner with us and take your business to the next level with our skilled and qualified tech-inclined graduates.",
          status: false,
          img: "talent-out",
        },

        {
          id: id++,
          scheme: "Mobile App Development",
          paragraph:
            "As Android developers, we offer reliable and efficient mobile app development services using Java/Kotlin, XML, and Android Studio. We design, develop, test, and publish user- friendly apps on the Google Play Store that meet your business requirements and help you stand out in the crowded app market.",
          status: false,
          img: "service3",
        },

        {
          id: id++,
          scheme: "Web Development",
          paragraph:
            "As professional website developers, we specialize in creating stunning, responsive websites that captivate your audience and elevate your brand's online presence. Our team of experienced developers and designers works closely with you to ensure your website meets your business objectives and user needs. From simple landing pages to complex e- commerce websites, we craft tailor-made solutions that leave a lasting impression on your visitors. With our expertise and attention to detail, we can help you achieve your online goals and stand out in the competitive digital landscape.",
          status: false,
          img: "service5",
        },
      ],
      clickedService: {
        id: id++,
        scheme: "Corporate Training",
        paragraph:
          "Our corporate training services offer customized learning solutions that cater to businesses' unique needs. We provide practical and interactive training that helps organizations enhance their employees' skills and productivity. We are committed to delivering high- quality training that drives business success. ",
        status: false,
        img: "service1",
      },
    };
  },

  components: {
    Contact,
  },

  methods: {
    // showCard(service) {
    //   console.log(service);
    //   this.clickedService = service
    // },
    
    showCard(service) {
    // Prevent the default link behavior
    // preventDefault();
    
    // Scroll to the section containing the service details
    document.querySelector('#service-details').scrollIntoView({ behavior: 'smooth' });

    // Update the clickedService data to show the details
    this.clickedService = service; 
  }
  },
};
</script>

<style scoped>
* {
  font-family: "Inter", sans-serif;
}
.rowing {
  margin-top: 4.7rem;
}

/* for images */
.body-service {
  background: url(../assets/Images/serve.png);
  height: 100vh;
  object-fit: cover;
  background-size: cover;
  background-position: center;
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.1);
}

.excel-pic {
  width: 350px;
  border-radius: 5px;
  height: 300px;
  object-fit: cover;
}

.contact-image img {
  width: 667px;
  height: 538px;
}
.serving {
  background: #f9f9f9;
}

.color {
  color: #ffffff;
}
/* for styling of h tags */
.color h1 {
  font-style: normal;
  line-height: 77px;
  font-weight: 700;
  font-size: 64px;
}
.using h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 39px;
  color: #000000;
}
.our-service h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  color: #1f1f1f;
}
.android h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  color: #335ca6;
}

.excel-header {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  color: #000000;
}

/* styling of p tags */

.excel p {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 35px;
  color: #404040;
}

.our-service p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}
.color p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  padding: 0 398px;
}
p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

.set {
  margin-top: -11px;
}
.go-up {
  gap: 9px;
}
.tool {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #335ca6;
}
.using p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #404040;
}
small {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
}

.link {
  text-decoration: none;
  font-weight: bold;
  color: #335ca6 !important;
  border: 1px solid #335ca6;
  border-radius: 7px;
  padding:5px 17px;
  margin-top:0px;
}

.go-up {
  text-decoration: none;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
  color: #335ca6;
}
/* for borders */
.training {
  background: #ffffff;
  border-radius: 10px;
  border: 2px solid transparent;
  transition: all 0.5s ease-out;
}

/* starting of hover effect */
.training:hover,
.training:focus {
  background: #d8e2f3;
  border: 2px solid #335ca6;
}

/* ending of hover effects */

.contact-us {
  background: #f9f9f9;
}

.image img {
  width: 100px;
  height: 100px;
  margin-bottom: 1.7rem;
}

/* for margins */
.language {
  margin-top: 5rem;
}
.ram {
  margin-bottom: 1.9rem;
}

.android {
  margin-top: 3.5rem;
}

.start {
  padding: 13px 30px;
  background: #335ca6;
  border-radius: 8px;
  color: #f9f9f9 !important;
  text-decoration: none;
  border: none !important;
  text-align: center;
}

.button {
  margin-top: 2rem;
}

img:hover {
  opacity: 0.9;
}

.excel-btn {
  border: none;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

/* for responsive design */

@media screen and (max-width: 768px) {
  .training {
    background: none;
  }

  .training:hover {
    background: none !important;
    border: none;
  }
  /* starting of hover effect*/
  .app-development:hover {
    background: none !important;
    border: none;
  }
  .product-dev:hover {
    background: none !important;
    border: none;
  }

  .image img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  /* ending of hover effect */
  .body-service {
    height: 360px;
  }
  .our-service h2 {
    font-size: 37px;
  }
  .android {
    margin-top: -29px;
  }
  /* .our-service p {
    padding: 0px 140px;
    font-size: 17px;
  } */
  .color p {
    padding: 0 0px;
    width: 372px;
    font-size: 24px;
  }

  .contact-me {
    background: #335ca6;
    border-radius: 8px;
    width: 180px;
    height: 48px;
    color: #ffffff;
    border: none;
  }
  /* .android {
    text-align: center;
  } */

  .rem {
    margin-bottom: 1.9rem;
  }

  .focus img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 42px;
  }
  .minia {
    text-align: center;
  }
  .excel {
    text-align: center;
  }
  .excel h3 {
    font-size: 34px;
  }

  .excel p {
    font-size: 17px;
    padding: 0px 137px;
  }

  .button {
    position: relative;
    top: 508px;
    display: flex;
    justify-content: center;
  }

  .reversing {
    flex-direction: column-reverse;
  }

  .flexing {
    margin-top: -54px;
    margin-bottom: 50px;
  }

  .flexing img {
    margin-right: auto;
    margin-left: auto;
    display: block;
    width: 646px;
  }

  .personal {
    width: 664px;
  }

  .forming {
    width: 664px;
  }

  .contact-image img {
    height: 328px;
    margin-bottom: 16px;
  }

  p {
    font-size: 15px;
  }
}

@media screen and (max-width: 425px) {
  .training {
    background: none;
    border: none;
  }

  .flexing img {
    width: 585px;
  }
  .training:hover {
    background: none;
  }
  .button {
    position: relative;
    top: 477px;
    display: flex;
    justify-content: center;
  }

  .flexing {
    margin-top: -49px;
    margin-bottom: 57px;
  }
  .image img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .person {
    padding: 0 102px;
    font-size: 18px;
    margin: 12px 0px;
  }
  /* .serving {
    width: 630px;
  }
  .body-service {
    width: 630px;
  } */

  .excel {
    text-align: center;
  }

  .excel h3 {
    font-size: 29px;
  }
  .excel p {
    padding: 0 49px;
    font-size: 16px;
  }
  /* .rating-me {
    width: 630px;
  }
  .contact-us {
    width: 630px;
  } */

  .color p {
    width: 278px;
    font-size: 16px;
  }
  /* p {
    padding: 0px 91px;
    margin-top: 23px;
    font-size: 17px;
  } */

  .image img {
    margin-bottom: 10px;
  }
  /* .our-service p {
    padding: 0px 78px;
    font-size: 17px;
  } */
  .contact-me {
    background: #335ca6;
    border-radius: 8px;
    width: 180px;
    height: 48px;
    color: #ffffff;
    border: none;
  }

  .minia {
    text-align: center;
  }

  .training {
    margin: 0px 20px;
  }
  /* for small screen forms and button */
  .personal {
    width: 400px;
    height: 49px;
  }

  .stating {
    padding: 0px 10px;
  }
  .forming {
    width: 400px;
  }
  .contact-image img {
    width: 667px;
    height: 300px;
    padding: 0 8px;
  }

  .using {
    margin-top: 16px;
    padding: 0 8px;
  }

  .reversing {
    flex-direction: column-reverse;
  }
  .sub {
    margin-top: 0px;
  }
}
@media screen and (max-width: 375px) {
  .image img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (max-width: 320px) {
  .image img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
